
const icons = [];

icons['A'] = props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
        <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
        <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
    </svg>

icons['B'] = props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
       <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
    </svg>

icons['C']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
       <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
    </svg>

icons['D']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
        <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
        <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
        <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       </svg>

icons['E']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
         <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
         <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
         <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
         <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
    </svg>

icons['F']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
          <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
          <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
          <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
     </svg>

icons['G']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
         <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
         <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
    </svg>

icons['H']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
        <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
        <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
        <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
   </svg>

icons['I']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
       <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
  </svg>


icons['J'] = props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
        <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
        <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       <circle r={props.strokeWidth} cx="50%" cy="50%" />
    </svg>

icons['K'] = props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
       <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
      <circle r={props.strokeWidth} cx="50%" cy="50%" />
    </svg>

icons['L']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
       <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
      <circle r={props.strokeWidth} cx="50%" cy="50%" />
    </svg>

icons['M']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
    <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
    <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
    <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
    <circle r={props.strokeWidth} cx="50%" cy="50%" />
  </svg>

icons['N']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
     <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
     <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
     <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
     <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
    <circle r={props.strokeWidth} cx="50%" cy="50%" />
</svg>

icons['O']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
        <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
        <line x1="80%" y1="80%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
        <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
       <circle r={props.strokeWidth} cx="50%" cy="50%" />
   </svg>

icons['P']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
       <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
      <circle r={props.strokeWidth} cx="50%" cy="50%" />
  </svg>

icons['Q']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
      <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
      <line x1="80%" y1="20%" x2="80%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
      <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
     <circle r={props.strokeWidth} cx="50%" cy="50%" />
 </svg>

icons['R']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
       <line x1="20%" y1="20%" x2="80%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
       <line x1="20%" y1="20%" x2="20%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
      <circle r={props.strokeWidth} cx="50%" cy="50%" />
  </svg>

icons['S']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
      <line x1="20%" y1="20%" x2="50%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
      <line x1="80%" y1="20%" x2="50%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
 </svg>

icons['T']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
     <line x1="20%" y1="20%" x2="80%" y2="50%" stroke="black" stroke-width={props.strokeWidth} />
     <line x1="20%" y1="80%" x2="80%" y2="50%" stroke="black" stroke-width={props.strokeWidth} />
</svg>

icons['U']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
    <line x1="80%" y1="20%" x2="20%" y2="50%" stroke="black" stroke-width={props.strokeWidth} />
    <line x1="80%" y1="80%" x2="20%" y2="50%" stroke="black" stroke-width={props.strokeWidth} />
</svg>

 icons['V']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
     <line x1="20%" y1="80%" x2="50%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
     <line x1="80%" y1="80%" x2="50%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
 </svg>

icons['W']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
     <line x1="20%" y1="20%" x2="50%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
     <line x1="80%" y1="20%" x2="50%" y2="80%" stroke="black" stroke-width={props.strokeWidth} />
     <circle r={props.strokeWidth} cx="50%" cy="50%" />
</svg>

icons['X']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
    <line x1="20%" y1="20%" x2="80%" y2="50%" stroke="black" stroke-width={props.strokeWidth} />
    <line x1="20%" y1="80%" x2="80%" y2="50%" stroke="black" stroke-width={props.strokeWidth} />
    <circle r={props.strokeWidth} cx="50%" cy="50%" />
</svg>

icons['Y']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
   <line x1="80%" y1="20%" x2="20%" y2="50%" stroke="black" stroke-width={props.strokeWidth} />
   <line x1="80%" y1="80%" x2="20%" y2="50%" stroke="black" stroke-width={props.strokeWidth} />
   <circle r={props.strokeWidth} cx="50%" cy="50%" />
</svg>

icons['Z']= props => <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height}>
<line x1="20%" y1="80%" x2="50%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
<line x1="80%" y1="80%" x2="50%" y2="20%" stroke="black" stroke-width={props.strokeWidth} />
<circle r={props.strokeWidth} cx="50%" cy="50%" />
</svg>

export default icons;
